export default {
  name: 'VsOptions',
  functional: true,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  render(h, data) {
    const items = data.props.items
    if (!items) return null

    const slots = data.scopedSlots.default || (() => null)
    return items.map(props => h('vs-option', { props }, slots(props)))
  }
}
